const debounceDuration = 500;
const safeValue = (value) => value || "";
const navigationMapBuilder = (parentRoute, navigation,layout) =>
  navigation.map((n) => ({
    ...n,    
    links: n.links.map((l) => ({ ...l, route: `${parentRoute}/${l.route}`,layout })),
  }));

export { debounceDuration, safeValue, navigationMapBuilder };
